<div class="modal-backdrop">
  <div class="modal-dialog" (clickOutside)="backdropClick.emit()">
    <div class="modal-header">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="modal-content">
      <ng-content select="[content]"></ng-content>
    </div>
    <div class="modal-footer">
      <ng-content select="[footer]"></ng-content>
    </div>
  </div>
</div>